import { lazyPipe, validateApiResponse, withApiErrorCapture } from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import urlJoin from 'url-join';
import z from 'zod';
import { privateHttpClient } from '../httpClient';
import { createApiResponseSchema } from '../utils';
import { campaignsApiPath } from './apiPath';

const SeedingDeliveryAddressItemSchema = z
  .object({
    /** 배송지 ID (수락/신청 API 의 deliveryAddressId) */
    id: z.number().int(),
    /** 배송지 별칭 (예: 집, 회사). 빈 값이면 null */
    addressName: z.string().nullable(),
    isPrimary: z.boolean(),
    name: z.string(),
    phone: z.string(),
    zipcode: z.string(),
    address1: z.string(),
    address2: z.string().nullable(),
    memo: z.string().nullable(),
  })
  .describe('SeedingDeliveryAddressItem');

export type SeedingDeliveryAddressItem = z.infer<typeof SeedingDeliveryAddressItemSchema>;

const GetSeedingDeliveryAddressesResponseDataSchema = z
  .object({
    addresses: z.array(SeedingDeliveryAddressItemSchema),
  })
  .describe('GetSeedingDeliveryAddressesResponseData');

const GetSeedingDeliveryAddressesResponseSchema = createApiResponseSchema(
  GetSeedingDeliveryAddressesResponseDataSchema,
);

export type GetSeedingDeliveryAddressesResponse = z.infer<
  typeof GetSeedingDeliveryAddressesResponseSchema
>;

export const getSeedingDeliveryAddresses = withApiErrorCapture(
  lazyPipe(async (): Promise<GetSeedingDeliveryAddressesResponse> => {
    return executeStandardRequest(async () =>
      privateHttpClient.get<GetSeedingDeliveryAddressesResponse>(
        urlJoin(campaignsApiPath.getSeedingDeliveryAddresses),
      ),
    );
  }, validateApiResponse(GetSeedingDeliveryAddressesResponseSchema)),
);
